export const userGroupListTabStorageKey = "userGroupListTabMetadata";
export const userGroupDetailsTabStorageKey = "userGroupDetailsTabMetadata";

export const loadUserGroupListTabsMetaData = () => {
  try {
    const serializedState = localStorage.getItem(userGroupListTabStorageKey);
    if (serializedState === null) {
      return {};
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const storeUserGroupListTabsMetadata = (_oldMetadata, newMetaData) => {
  try {
    const serializesState = JSON.stringify(newMetaData);
    localStorage.setItem(userGroupListTabStorageKey, serializesState);
  } catch (err) {
    console.error(err);
  }
};

export const loadUserGroupDetailsTabsMetaData = () => {
  try {
    const serializedState = localStorage.getItem(userGroupDetailsTabStorageKey);
    if (serializedState === null) {
      return {};
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const storeUserGroupDetailsTabsMetadata = (_oldMetadata, newMetaData) => {
  try {
    const serializesState = JSON.stringify(newMetaData);
    localStorage.setItem(userGroupDetailsTabStorageKey, serializesState);
  } catch (err) {
    console.error(err);
  }
};
